import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const FETCH_PAYMENT_INTENTS_REQUEST = 'app/PaymentIntentsPage/FETCH_PAYMENT_INTENTS_REQUEST';
export const FETCH_PAYMENT_INTENTS_SUCCESS = 'app/PaymentIntentsPage/FETCH_PAYMENT_INTENTS_SUCCESS';
export const FETCH_PAYMENT_INTENTS_ERROR = 'app/PaymentIntentsPage/FETCH_PAYMENT_INTENTS_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  fetchError: null,
  paymentIntents: [],
  total: 0,
};

export default function paymentIntentsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_PAYMENT_INTENTS_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_PAYMENT_INTENTS_SUCCESS:
      return {
        ...state,
        fetchInProgress: false,
        paymentIntents: payload.data || [],
        total: payload.total || 0,
      };
    case FETCH_PAYMENT_INTENTS_ERROR:
      console.error(payload);
      return { ...state, fetchInProgress: false, fetchError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchPaymentIntentsRequest = () => ({ type: FETCH_PAYMENT_INTENTS_REQUEST });

const fetchPaymentIntentsSuccess = response => ({
  type: FETCH_PAYMENT_INTENTS_SUCCESS,
  payload: response,
});

const fetchPaymentIntentsError = e => ({
  type: FETCH_PAYMENT_INTENTS_ERROR,
  payload: e,
  error: true,
});

// ================ Thunks ================ //

export const loadData = ({ statusFilters, createdAtStart, createdAtEnd } = {}) => (
  dispatch,
  getState,
  sdk
) => {
  dispatch(fetchPaymentIntentsRequest());

  // Build query parameters for backend API
  const params = new URLSearchParams();
  
  if (statusFilters && statusFilters.length > 0) {
    statusFilters.forEach(status => params.append('status', status));
  }
  
  if (createdAtStart) {
    params.append('start', new Date(createdAtStart).toISOString().split('T')[0]);
  }
  
  if (createdAtEnd) {
    params.append('end', new Date(createdAtEnd).toISOString().split('T')[0]);
  }

  const queryString = params.toString();
  const url = `/api/payment-intents${queryString ? `?${queryString}` : ''}`;

  return fetch(url, {
    credentials: 'include',
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      return response.json();
    })
    .then(data => {
      dispatch(fetchPaymentIntentsSuccess(data));
      return data;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(fetchPaymentIntentsError(error));
      throw error;
    });
};

